import React from 'react';
import { Box, Button, Card, Paragraph } from 'bumbag';
import _get from 'lodash/get';
import Loads from 'react-loads';
import { Link as RouterLink } from 'react-router-dom';

import { CardDetailsBox } from '@medipass/react-core';
import { WithErrorMessage } from '@medipass/react-core';
import { WithLoadingIndicator } from '@medipass/react-core';
import sdk from '@medipass/web-sdk';

import Page from 'legacy/components/account/layout/Page';
import WithAuthentication from 'legacy/components/WithAuthentication';
import WithEmpty from 'legacy/components/WithEmpty';
export default class PaymentMethods extends React.Component<{}> {
  deletePaymentMethod = async (paymentMethodId: string, getAccountPaymentMethods: (...args: Array<any>) => any) => {
    const accountId = _get(sdk, 'account._id');

    await sdk.payments.deleteAccountPaymentMethod(accountId, paymentMethodId);
    getAccountPaymentMethods();
  };
  getAccountPaymentMethods = () => {
    const accountId = _get(sdk, 'account._id');

    return sdk.payments.getAccountPaymentMethods(accountId);
  };
  render = () => (
    <WithAuthentication>
      <Page minWidthBreakpoint="mobile" title="Payment methods">
        <Box marginBottom="major-2" textAlign="right">
          <Button
            // @ts-expect-error
            use={RouterLink}
            variant="ghost"
            palette="primary"
            fontWeight="semibold"
            to="/account/payment-methods/create/"
          >
            <i className="fa fa-sm fa-plus margin-right-5" />
            Add a new payment method
          </Button>
        </Box>
        <Loads contextKey="paymentMethods" loadOnMount load={this.getAccountPaymentMethods}>
          {/* @ts-expect-error TS(7031): Binding element 'getAccountPaymentMethods' implici... Remove this comment to see the full error message */}
          {({ load: getAccountPaymentMethods, error, response: items, isError, isLoading, isSuccess }) => (
            <Card>
              <p className="font-semibold">Payment methods</p>
              <WithLoadingIndicator isActive={isLoading}>
                <WithErrorMessage isActive={isError} description="Unable to load your payment methods" error={error}>
                  <WithEmpty
                    isActive={isSuccess && _get(items, 'length') === 0}
                    emptyText={<Paragraph>You do not have any payment methods linked to your account.</Paragraph>}
                  >
                    {items &&
                      // @ts-expect-error TS(7006): Parameter 'item' implicitly has an 'any' type.
                      items.map(item => (
                        <Loads key={item._id} load={this.deletePaymentMethod}>
                          {/* @ts-expect-error TS(7031): Binding element 'handleDeletePaymentMethod' implic... Remove this comment to see the full error message */}
                          {({ load: handleDeletePaymentMethod, isLoading }) => (
                            <CardDetailsBox
                              data-testid="payment-method"
                              addonComponent={
                                <Button
                                  palette="danger"
                                  variant="ghost"
                                  isLoading={isLoading}
                                  onClick={() => handleDeletePaymentMethod(item._id, getAccountPaymentMethods)}
                                >
                                  <i className="fa fa-sm fa-trash-alt margin-right-5" />
                                  Remove
                                </Button>
                              }
                              className="margin-top-10 margin-bottom-10"
                              lastFour={item.lastFour}
                              type={item.cardType}
                            />
                          )}
                        </Loads>
                      ))}
                  </WithEmpty>
                </WithErrorMessage>
              </WithLoadingIndicator>
            </Card>
          )}
        </Loads>
      </Page>
    </WithAuthentication>
  );
}
